import Vue from 'vue'
export default new Vue();


// WEBPACK FOOTER //
// ./src/view/unitmanage/bus.js